import { render } from "./BasicDataComponent.vue?vue&type=template&id=82a87d68"
import script from "./BasicDataComponent.vue?vue&type=script&lang=js"
export * from "./BasicDataComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__